import { Select } from "@/components/ui/select"

// 総戸数の選択肢（1戸〜500戸）
const unitsOptions = Array.from({ length: 500 }, (_, i) => ({
  value: (i + 1).toString(),
  label: `${i + 1}戸`,
}))

interface PropertyUnitsSelectorProps {
  value: number | undefined
  onChange: (value: number) => void
  error?: string
  placeholder?: string
  disabled?: boolean
  className?: string
}

export function PropertyUnitsSelector({
  value,
  onChange,
  error,
  placeholder = "選択してください",
  disabled = false,
  className,
}: PropertyUnitsSelectorProps) {
  return (
    <div className={className}>
      <Select
        value={value?.toString() || ""}
        onChange={(val: string) => onChange(Number(val))}
        options={unitsOptions}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}
